export const formatdatetime = {
    // directive definition
    bind: function (el, binding) {
        if (binding.value) {
            let objData = new Date(binding.value);
            el.innerHTML = objData.toLocaleDateString('pt-BR') + '<br/>às ' + objData.toLocaleTimeString('pt-BR');
        }
        else
            el.innerHTML = '';
    }
}

